import { TransportService } from "./transportService";
const transportService = new TransportService();

const AuthLogsApi = {
  getAuthLogs: (page = 1) => transportService.requestData("GetAuthLogs", null, { page: page }),
  searchAuthLogs: query => transportService.requestData("SearchAuthLogs", null, null, query),
};

export default AuthLogsApi;
